import {Znamka} from './znamka';

export class PredmetySection {

  castSp: string;
  typVyucby: string;
  kredit: number;
  kreditZiskany: number;
  predmety: Znamka[];

  castSpKod: string;
  typVyucbyKod: string;

}
